import $ from "jquery";
import FitlerFactory from "./Filters/FilterFactory";
export default class Filter {
    static mount() {
        $(function () {
            let $nodes = $('.filterable');
            for (let i = 0; i < $nodes.length; i++) {
                new Filter($($nodes[i]));
            }
        });
    }
    constructor($parent) {
        this.$parent = $parent;
        this.$filterform = $('.filterable-filter-form', this.$parent);
        this.$filterform.on('submit', (function (e) {
            e.preventDefault();
        }));
        this.$items = $('.filterable-item', this.$parent);
        this.$loadMoreButton = $('.wp-block-buttons--loadmore', this.$parent);
        this.filtersetStorageKey = this.$parent.data('filtersetstoragekey');
        this.loadMoreStep = parseInt(this.$parent.data('loadmorestep'));
        this.maxItemsVisible = parseInt(this.$parent.data('maxitems'));
        this.buildFilter();
        this.initFilterValues();
        this.$filterNodes.on("change", () => {
            this.filter();
        });
        this.$filterNodes.on("input", () => {
            this.filter();
        });
        this.filter();
        this.$loadMoreButton.on('click', () => { this.maxItemsVisible += this.loadMoreStep; this.filter(); });
    }
    initFilterValues() {
        const data = sessionStorage.getItem(this.filtersetStorageKey);
        if (!data)
            return;
        const sessionStorageFilterSet = JSON.parse(data);
        for (let j = 0; j < this.filterList.length; j++) {
            let filter = this.filterList[j];
            filter.loadData(sessionStorageFilterSet);
        }
        const maxItemsVisibleSettings = sessionStorageFilterSet.find((element) => element.key === 'maxItemsVisible');
        if (maxItemsVisibleSettings) {
            this.maxItemsVisible = maxItemsVisibleSettings.value;
        }
        for (let j = 0; j < this.filterList.length; j++) {
            let filter = this.filterList[j];
            filter.checkParameterForInitValue();
        }
    }
    saveFilterValues() {
        let newData = [];
        for (let j = 0; j < this.filterList.length; j++) {
            let filter = this.filterList[j];
            newData.push(filter.getData());
        }
        newData.push({
            key: 'maxItemsVisible',
            value: this.maxItemsVisible
        });
        const sessionData = JSON.stringify(newData);
        sessionStorage.setItem(this.filtersetStorageKey, sessionData);
    }
    buildFilter() {
        this.filterList = [];
        this.$filterNodes = $('.filterable-filter', this.$filterform);
        for (let i = 0; i < this.$filterNodes.length; i++) {
            let $node = $(this.$filterNodes[i]);
            const filter = FitlerFactory.createFilter($node);
            if (filter !== null) {
                this.filterList.push(filter);
            }
        }
    }
    filter() {
        let countVisible = 0;
        let potCount = 0;
        for (let i = 0; i < this.$items.length; i++) {
            let $item = $(this.$items[i]);
            if (this.isItemVisible($item)) {
                potCount++;
                if (countVisible >= this.maxItemsVisible) {
                    $item.hide();
                    this.$loadMoreButton.css("display", 'flex');
                }
                else {
                    $item.show();
                    countVisible++;
                }
            }
            else {
                $item.hide();
            }
        }
        if (countVisible < this.maxItemsVisible || countVisible === potCount) {
            this.$loadMoreButton.css("display", 'none');
        }
        this.saveFilterValues();
    }
    isItemVisible($item) {
        for (let j = 0; j < this.filterList.length; j++) {
            let filter = this.filterList[j];
            if (!filter.match($item)) {
                return false;
            }
        }
        return true;
    }
}
